import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

export const storeOnboardingAdminPermissions = {
  view: "storeOnboardingAdmin.view",
  delete: "storeOnboardingAdmin.delete",
  // Approve / reject the information a client submitted from the dashboard (Phase 3). Not a subscription decision.
  review: "storeOnboardingAdmin.review",
};

export const storeOnboardingAdminGrants = {
  "storeOnboardingAdmin.view": rule(lud(R.DMM, R.AM)),
  "storeOnboardingAdmin.delete": rule(lud()),
  "storeOnboardingAdmin.review": rule(lud(R.AM)),
};
